import React from 'react';
import { useSearchParams } from 'react-router-dom';

import ClientWizard from './client-wizard';
import ClientsList from './clients-list';

const NEW_CLIENT = 'new';

/**
 * Une seule route (/internal/clients) pour la liste et l'assistant : la section
 * OUTILS INTERNES n'est protégée qu'au niveau des routes de navigation, une route
 * technique dédiée à l'assistant serait accessible sans être SUPER-ADMIN.
 * L'étape affichée est portée par le paramètre `client` (`new` ou un id).
 */
const InternalClients = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const clientParam = searchParams.get('client');

  const openList = () => setSearchParams({});
  const openClient = (clientId) =>
    setSearchParams({ client: String(clientId) });

  const clientId =
    clientParam && clientParam !== NEW_CLIENT ? Number(clientParam) : null;
  const isClientParamValid =
    clientParam === NEW_CLIENT || (Number.isInteger(clientId) && clientId > 0);

  if (!clientParam || !isClientParamValid) {
    return (
      <ClientsList
        onCreate={() => setSearchParams({ client: NEW_CLIENT })}
        onEdit={openClient}
      />
    );
  }

  return (
    <ClientWizard
      clientId={clientId}
      onClientCreated={(createdClientId) =>
        setSearchParams({ client: String(createdClientId) }, { replace: true })
      }
      onExit={openList}
    />
  );
};

export default InternalClients;
